'use client';

import React, { createContext, useContext, ReactNode } from 'react';

/**
 * Carries the per-request CSP nonce (generated in src/proxy.ts, read from the
 * x-nonce header in the root layout) down to client components that render
 * retailer-configured HTML, so they can stamp it onto <script> tags they emit.
 *
 * Trust model: the nonce marks "sutro rendered this". Retailer-configured
 * scripts (header HTML, banners) are part of the product and are rendered by
 * sutro, so they get the nonce; anything injected into the page outside
 * sutro's render path (extensions, XSS) never can.
 */
const NonceContext = createContext<string | undefined>(undefined);

export function NonceProvider({
  nonce,
  children,
}: {
  nonce?: string;
  children: ReactNode;
}): React.ReactElement {
  return (
    <NonceContext.Provider value={nonce}>{children}</NonceContext.Provider>
  );
}

export function useNonce(): string | undefined {
  return useContext(NonceContext);
}
